import React, { useEffect, useState } from 'react';
import { IconClose } from '~/assets/Icons';
import { Button, Input, Modal, Select } from '~/components';
import { CloseButton, ContainerInput, Title } from './styles';
import sectorService from '~/services/sectorService';
import { currentYearString } from '~/utils/dates';

interface IProps {
  onClickClose: () => void;
  onChange: (e: any) => void;
}

const ModalAddFilters: React.FC<IProps> = ({
  onClickClose,
  onChange,
}: IProps) => {
  const [initialDate, setInitialDate] = useState(`${currentYearString}-01-01`);
  const [finalDate, setFinalDate] = useState(`${currentYearString}-12-31`);
  const [currentSectorId, setCurrentSectorId] = useState<any>(undefined);
  const [loading, setLoading] = useState(true);
  const [listSector, setListSector] = useState<any>([]);
  const [currentSectorName, setCurrentSectorName] = useState<any>('');
  const erro = '';

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const response = await sectorService.listSector({ limit: 200, page: 1 });
      setListSector(response.result);
      setLoading(false);
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal>
      <>
        <CloseButton onClick={() => onClickClose()}>
          <IconClose />
        </CloseButton>
        <Title>Filtrar</Title>
        <ContainerInput>
          <Input
            type="date"
            value={initialDate}
            onChange={e => setInitialDate(e.target.value)}
            label="Início"
          />
          <Input
            type="date"
            value={finalDate}
            onChange={e => setFinalDate(e.target.value)}
            label="Fim"
          />
        </ContainerInput>
        <Select
          label={loading ? 'Carregando...' : 'Setor'}
          erro={erro}
          lista={listSector}
          currentValue={currentSectorName}
          onClickList={item => {
            setCurrentSectorName(item.name);
            setCurrentSectorId(item.id);
          }}
        />
        <div style={{ height: '30px' }} />
        <Button
          onClick={() => {
            onChange({
              initialDate,
              finalDate,
              currentSectorId,
            });
            onClickClose();
          }}
        >
          Filtrar
        </Button>
        <div style={{ height: '10px' }} />
        {/* <Button
          styles={1}
          onClick={() => {
            onChange({
              initialDate,
              finalDate,
              currentSectorId,
              hasComments,
              isOutOfDate,
            });
            onClickClose();
          }}
        >
          Limpar filtros
        </Button> */}
      </>
    </Modal>
  );
};

export default ModalAddFilters;
